import { type ApiResponse, newRequest } from "std/api/newRequest";
import type { TApiLancamentos } from "../pages/lancamentos";
import type { ApiRelatorioGetParams } from "../types/ApiRelatorioParams";

export function apiRelLancamentos({ params }: { params: ApiRelatorioGetParams }): Promise<ApiResponse<TApiLancamentos>> {
	return newRequest({
		url: "Relatorio/Lancamento",
		type: "get",
		idpk: undefined,
		params,
	});
}
